import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map ,delay} from 'rxjs/operators';

import { AppGlobals } from '../shared/app.global';



  

@Injectable()
export class ScheduleService {

    callurl: string = '';
    noteapi:string="http://49.205.199.224:3031/";
  
    clcd:string;
    aycd:string;
    usid:string;
    
        constructor(private http: HttpClient,private _global: AppGlobals) {
    
           this.clcd=localStorage.getItem('clcd');
           this.aycd=localStorage.getItem('aycd');
           this.usid=localStorage.getItem('usid');
         
           this.callurl=_global.baseAPIUrl;
         }

         
         getdatetoday()
         {
          let d: Date = new Date();
          var mnth;
          var day='';
          //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
          if(d.getMonth()>=10)
          {
            mnth=d.getMonth()+1;
          }
          else{
           // mnth='0'+d.getMonth()+1;
           mnth=d.getMonth()+1;
           mnth='0'+mnth;
          }
       
          if(d.getDate()>=10)
          {
            day=d.getDate().toString();
          }
          else{
            day='0'+d.getDate();
          }
          let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
            
       return todayDate;
       
         }
        
  save_sp_classteacher(empdata: any): Observable<any> {
    return this.http.post(this._global.baseAPIUrl + 'save_sp_classteacher', empdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}


sel_sp_schasssch(clid,assid,asstypeid,baid) {
    debugger;
    let clcd=this.clcd;
    let aycd=this.aycd;
    //console.log('url',this._global.baseAPIUrl + 'sel_sp_schasssch/'+clcd+'/'+aycd+'/'+clid+'/'+assid+'/'+asstypeid+'/'+baid);
    return this.http.get(this._global.baseAPIUrl + 'sel_evltschedule/'+clcd+'/'+aycd+'/'+clid+'/'+assid+'/'+asstypeid+'/'+baid)
        .pipe(map((data: any) => {
            return data.sp_schasssch;
        }));
    }

    
sel_evlschedule(clid,assid,asstypeid,baid) {
    debugger;
    let clcd=this.clcd;
    let aycd=this.aycd;
    console.log('url',this._global.baseAPIUrl + 'sel_sp_schasssch/'+clcd+'/'+aycd+'/'+clid+'/'+assid+'/'+asstypeid);
    return this.http.get(this._global.baseAPIUrl + 'sel_sp_schasssch/'+clcd+'/'+aycd+'/'+clid+'/'+assid+'/'+asstypeid)
        .pipe(map((data: any) => {
            return data.sp_schasssch;
        }));
    }
        save_sp_schasssch(empdata: any): Observable<any> {
            empdata.usid=this.usid;
            return this.http.post(this._global.baseAPIUrl + 'save_evltschedule', empdata)
                .pipe(map((data: any) => {
                    console.log('retres', data);
                    return data;
                }));
        }

        sel_sp_schholidaylist() {
            let clcd=this.clcd;
            let aycd=this.aycd;
            console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
            return this.http.get(this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd)
                .pipe(map((data: any) => {
                    return data.sp_schholidaylist;
                }));
            }

            save_sp_schholidaylist(empdata: any): Observable<any> {
                return this.http.post(this._global.baseAPIUrl + 'save_sp_schholidaylist', empdata)
                    .pipe(map((data: any) => {
                        console.log('retres', data);
                        return data;
                    }));
            }
            sel_sp_schyearlycalendar() {
                let clcd=this.clcd;
                let aycd=this.aycd;

                console.log('url',this._global.baseAPIUrl + 'sel_sp_schyearlycalendar/'+clcd+'/'+aycd);
                return this.http.get(this._global.baseAPIUrl + 'sel_sp_schyearlycalendar/'+clcd+'/'+aycd)
                    .pipe(map((data: any) => {
                        return data.sp_schyearlycalendar;
                    }));
                }

                sel_schyearcalendar(tag) {
                    let clcd=this.clcd;
                    let aycd=this.aycd;
    
                    console.log('url',this._global.baseAPIUrl + 'sel_schyearcalendar/'+clcd+'/'+aycd+'/'+tag);
                    return this.http.get(this._global.baseAPIUrl + 'sel_schyearcalendar/'+clcd+'/'+aycd+'/'+tag)
                        .pipe(map((data: any) => {
                            return data.arrcallist;
                        }));
                    }

                save_sp_schyearlycalendar(empdata: any): Observable<any> {
                    return this.http.post(this._global.baseAPIUrl + 'save_sp_schyearlycalendar', empdata)
                        .pipe(map((data: any) => {
                            console.log('retres', data);
                            return data;
                        }));
                }

                save_schyearcalendar(empdata: any): Observable<any> {
                    return this.http.post(this._global.baseAPIUrl + 'save_schyearcalendar', empdata)
                        .pipe(map((data: any) => {
                            console.log('retres', data);
                            return data;
                        }));
                }

                gen_schyearcalendar(empdata: any): Observable<any> {
                    return this.http.post(this._global.baseAPIUrl + 'generate_schyearcalendar', empdata)
                        .pipe(map((data: any) => {
                            console.log('retres', data);
                            return data;
                        }));
                }

                sel_sp_masoccation() {
                    let clcd=this.clcd;
                    let aycd=this.aycd;
                    return this.http.get(this._global.baseAPIUrl + 'sel_sp_masoccation/'+clcd+'/'+aycd)
                        .pipe(map((data: any) => {
                            return data.sp_masoccation;
                        }))
                }
                save_sp_masoccation(secdata: any): Observable<any> {
                    secdata.clcd=this.clcd;
                    secdata.aycd=this.aycd;
                    return this.http.post(this._global.baseAPIUrl + 'save_sp_masoccation', secdata)
                        .pipe(map((data: any) => {
                            console.log('retres', 'response');
                            return data
                        }));
                }


                getschnotification() {
                    let clcd=this.clcd;
                    let aycd=this.aycd;
                    var pstdata={clcd:this.clcd,aycd:this.aycd};
                   // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
                    return this.http.post(this._global.baseAPIUrl + 'getnotifications',pstdata)
                        .pipe(map((data: any) => {
                            return data.notelst;
                        }));
                    }

                    getstunotification() {
                        let clcd=this.clcd;
                        let aycd=this.aycd;
                        var pstdata={clcd:this.clcd,aycd:this.aycd};
                       // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
                        return this.http.post(this._global.baseAPIUrl + 'getnotificationstu',pstdata)
                            .pipe(map((data: any) => {
                                return data.notelst;
                            }));
                        }

                        getresource(obj) {
                            let clcd=this.clcd;
                            let aycd=this.aycd;
                            var pstdata={clcd:this.clcd,aycd:this.aycd,clid:obj.clid,crid:obj.crid};
                           // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
                            return this.http.post(this._global.baseAPIUrl + 'getclresource',pstdata)
                                .pipe(map((data: any) => {
                                    return data;
                                }));
                            }
    
                            delresource(obj) {
                                let clcd=this.clcd;
                                let aycd=this.aycd;
                                var pstdata={clcd:this.clcd,aycd:this.aycd,usid:this.usid,reid:obj};
                               // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
                                return this.http.post(this._global.baseAPIUrl + 'delclresource',pstdata)
                                    .pipe(map((data: any) => {
                                        return data;
                                    }));
                                }
        
                    getschnotd(nfid) {
                        let clcd=this.clcd;
                        let aycd=this.aycd;
                        var pstdata={clcd:this.clcd,aycd:this.aycd,nfid:nfid};
                       // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
                        return this.http.post(this._global.baseAPIUrl + 'getnoted',pstdata)
                            .pipe(map((data: any) => {
                                return data.notelst;
                            }));
                        }

                        getstudents_clwise(clid,secid,crid): Observable<any> {
                            debugger
                            // let clcd=localStorage.getItem('clcd');
                            // let aycd=localStorage.getItem('aycd');libsubjectgroup
                            
                            return this.http.post(this.callurl + 'selstudent_clwise',{clcd:this.clcd,aycd:this.aycd,clid:clid,scid:secid,crid:crid})
                            .pipe(map((data: any) => {
                                    console.log('retres-data', data);
                                    return data.stulst;
                                    
                                }));
                          }
                      
                    delschnotification(nfid) {
                        debugger
                        let clcd=this.clcd;
                        let aycd=this.aycd;
                        var pstdata={clcd:this.clcd,aycd:this.aycd,nfid:nfid};
                       // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
                        return this.http.post(this._global.baseAPIUrl + 'delnotifications',pstdata)
                            .pipe(map((data: any) => {
                                return data;
                            }));
                        }
                        getnoteda(nfid) {
                            debugger
                            let clcd=this.clcd;
                            let aycd=this.aycd;
                           // var pstdata={clcd:this.clcd,aycd:this.aycd,nfid:nfid};
                           // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
                            return this.http.get(this._global.baseAPIUrl + 'getnotedf/'+this.clcd+'/'+this.aycd+'/'+nfid)
                                .pipe(map((data: any) => {
                                    return data.studoclst;
                                }));
                            }

                            delnoteda(nfid) {
                                debugger
                                let clcd=this.clcd;
                                let aycd=this.aycd;
                               // var pstdata={clcd:this.clcd,aycd:this.aycd,nfid:nfid};
                               // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
                                return this.http.get(this._global.baseAPIUrl + 'delnotedoc/'+this.clcd+'/'+this.aycd+'/'+nfid)
                                    .pipe(map((data: any) => {
                                        return data;
                                    }));
                                }
                        delnoted(nfid) {
                            debugger
                            let clcd=this.clcd;
                            let aycd=this.aycd;
                            var pstdata={clcd:this.clcd,aycd:this.aycd,rid:nfid};
                           // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
                            return this.http.post(this._global.baseAPIUrl + 'delnoted',pstdata)
                                .pipe(map((data: any) => {
                                    return data;
                                }));
                            }

                            uploadnoteda(data: File,nfid,fpath,ftype,fnm): Observable<any> {
                                /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';
                              debugger
                                const formData: FormData = new FormData();
                                //console.log("stuid",bkid)
                                if(ftype=='File')
                                {
                                formData.append('Image', data, data.name);
                                }
                                  formData.append('nfid', nfid);
                                  formData.append('fpath', fpath);
                                  formData.append('ftype', ftype);
                                  formData.append('fnm', fnm);
                                  formData.append('clcd', this.clcd);
                                  formData.append('aycd', this.aycd);
                                  formData.append('crby', this.usid);
                                  console.log("formData",formData);
                                 return this.http.post(this._global.baseAPIUrl + 'uploadnoteda', formData)
                                 .pipe(map((data: any) => {
                                     console.log('retres', data);
                                     return data
                                 }));
                              }
                          
                              save_uploadresource(data: File,objdata): Observable<any> {
                                /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';
                              debugger
                                const formData: FormData = new FormData();
                                //console.log("stuid",bkid)
                                if(data != null)
                                {
                                formData.append('Image', data, data.name);
                                }
                               // formData.append('Image', data, data.name);
                                  formData.append('clid', objdata.clid);
                                  formData.append('crid', objdata.crid);
                                  formData.append('recatid', objdata.recatid);
                                  formData.append('reclink', objdata.reclink);
                                  formData.append('retitle', objdata.retitle);
                                  formData.append('clcd', this.clcd);
                                  formData.append('aycd', this.aycd);
                                  formData.append('crby', this.usid);
                                  formData.append('reid', objdata.reid);
                                  formData.append('oprtype', objdata.oprtype);
                                  formData.append('fpath', objdata.fpath);
                                  console.log("formData",formData);
                                 return this.http.post(this._global.baseAPIUrl + 'save_uploadcomresource', formData)
                                 .pipe(map((data: any) => {
                                     console.log('retres', data);
                                     return data
                                 }));
                              }
                          
                    saveschnotification(empdata: any): Observable<any> {
                       // empdata.ayid='16';
                        empdata.usid=this.usid;
                        empdata.clcd=this.clcd;
                        empdata.aycd=this.aycd;
                        return this.http.post(this._global.baseAPIUrl + 'savenotification', empdata)
                            .pipe(map((data: any) => {
                                console.log('retres', data);
                                return data;
                            }));
                    }

                    savestunote(empdata: any): Observable<any> {
                        // empdata.ayid='16';
                         empdata.usid=this.usid;
                         empdata.clcd=this.clcd;
                         empdata.aycd=this.aycd;
                         return this.http.post(this._global.baseAPIUrl + 'save_stunoteh', empdata)
                             .pipe(map((data: any) => {
                                 console.log('retres', data);
                                 return data;
                             }));
                     }

                    getdbstr(): Observable<any> {
                       
                       // empdata.usid=this.usid;
                       var empdata={ clcd:this.clcd,aycd:this.aycd};
                       // empdata.aycd=this.aycd;
                        return this.http.post(this._global.baseAPIUrl + 'Getdbstr', empdata)
                            .pipe(map((data: any) => {
                                console.log('retres', data);
                                return data;
                            }));
                    }

                    savenodenotification(empdata: any): Observable<any> {
                        empdata.ayid='16';
                        empdata.usid=this.usid;
                        empdata.clcd=this.clcd;
                        empdata.aycd=this.aycd;
                        return this.http.post(this.noteapi + 'addnote', empdata)
                            .pipe(map((data: any) => {
                                console.log('retres', data);
                                return data;
                            }));
                    }

                    sendmarkssms(empdata: any): Observable<any> {
                        empdata.ayid='16';
                        empdata.usid=this.usid;
                        empdata.clcd=this.clcd;
                        empdata.aycd=this.aycd;
                        return this.http.post(this._global.baseAPIUrl + 'smsmarks', empdata)
                            .pipe(map((data: any) => {
                                console.log('retres', data);
                                return data;
                            }));
                    }



                    getschtimetable(clid,scid,daynm,crid) {
                        debugger
                        let clcd=this.clcd;
                        let aycd=this.aycd;
                       // var pstdata={clcd:this.clcd,aycd:this.aycd,nfid:nfid};
                       // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
                        return this.http.get(this._global.baseAPIUrl + 'getschtimetable/'+this.clcd+'/'+this.aycd+'/'+clid+'/'+scid+'/'+crid+'/'+daynm)
                            .pipe(map((data: any) => {
                                console.log('retres', data);
                                return data.canlist;
                            }));
                        }
                        saveschtimetable(ob1: any,ob2:any): Observable<any> {
                            var pstdata={clid:ob1.clid,scid:ob1.scid,daynm:ob1.daynm,prid:ob2.id,subid:ob2.subid,emid:ob2.emid,emid1:ob2.emid1,clcd:this.clcd,aycd:this.aycd,oprtype:ob1.oprtype,frtime:ob2.frtime,totime:ob2.totime,prtype:ob2.prtype,crid:ob1.crid};
                            console.log('pstdata',pstdata);
                            return this.http.post(this._global.baseAPIUrl + 'save_schtimetable', pstdata)
                                .pipe(map((data: any) => {
                                    console.log('retres', data);
                                    return data;
                                }));
                        }


                        getnotecls(nfid) {
                            debugger
                            let clcd=this.clcd;
                            let aycd=this.aycd;
                           // var pstdata={clcd:this.clcd,aycd:this.aycd,nfid:nfid};
                           // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
                            return this.http.get(this._global.baseAPIUrl + 'getnoteclassec/'+this.clcd+'/'+this.aycd+'/'+nfid)
                                .pipe(map((data: any) => {
                                    console.log('clsclst', data);
                                    return data.clsclst;
                                }));
                            }

                            save_noteh(ob1: any,ob2:any): Observable<any> {
                                var pstdata={clcd:this.clcd,aycd:this.aycd,oprtype:ob1.oprtype,nfid:ob1.nfid,nfcontent:ob1.nfcontent,loopdata:ob2,usid:this.usid};
                                console.log('pstdata',pstdata);
                                return this.http.post(this._global.baseAPIUrl + 'save_noteh', pstdata)
                                    .pipe(map((data: any) => {
                                        console.log('retres', data);
                                        return data;
                                    }));
                            }

                            delnote(nfid) {
                                debugger
                                let clcd=this.clcd;
                                let aycd=this.aycd;
                               // var pstdata={clcd:this.clcd,aycd:this.aycd,nfid:nfid};
                               // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
                                return this.http.get(this._global.baseAPIUrl + 'delete_noteh/'+this.clcd+'/'+this.aycd+'/'+nfid)
                                    .pipe(map((data: any) => {
                                        console.log('clsclst', data);
                                        return data;
                                    }));
                                }

}